/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { fieldsProjectsLimitsResource } from '@jira/router-resources__admin-pages-performance/src/fieldsProjectsLimitsResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsPerformanceCustomFieldProjectLimitRoute } from '@jira/router-routes__admin-pages-performance-routes/src/globalSettingsPerformanceCustomFieldProjectLimitRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { customFieldProjectLimitMetricDetailEntryPoint } from './ui/spa/admin-pages/performance/metric-detail/custom-field/project-limit/index.tsx';

export const globalSettingsPerformanceCustomFieldProjectLimitRouteEntry: Route = createEntry(
	globalSettingsPerformanceCustomFieldProjectLimitRoute,
	() => ({
		group: 'global-settings',

		entryPoint() {
			return customFieldProjectLimitMetricDetailEntryPoint;
		},

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			fieldsProjectsLimitsResource,
		],

		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
